<template>
  <div>
    <div class="quotas">
      <div>
        <wanted-completes :survey="survey" />

        <quota-panel :survey="survey" />

        <div class="buttons">
          <div class="add-agent" v-if="surveyTypeIsNotCAWI && hasQuota">
            <router-link
              :to="{ name: 'addagent', query: { surveyId: $route.query.survey } }"
            >
              {{ parseTranslation(ADD_AGENT) }}
            </router-link>
          </div>

          <button @click="save" class="btn-launch">
            <span v-if="!loadingSave">{{ parseTranslation(SAVE) }}</span>
            <span v-else>{{ parseTranslation(LOADING) }}...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import QuotaPanel from '@/pages/Quota/QuotaPanel.vue'
import WantedCompletes from '@/pages/Quota/WantedCompletes.vue'

import * as translationQuotaPanel from './index.translations'

const { default: translations, ...translationKeys } = translationQuotaPanel

export default {
  props: {
    survey: {
      required: true,
    },

    getSurvey: {
      required: true,
    },

    surveyTypeIsNotCAWI: {
      required: true,
    },
  },

  components: {
    QuotaPanel,
    WantedCompletes,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      loadingSave: false,
    }
  },

  computed: {
    ...mapState(['quotaJSON', 'completeChecker', 'quotaOrder', 'wantedCompletes']),

    hasQuota() {
      return this.survey?.quota
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async save() {
      if (this.loadingSave || this.completeChecker) return

      if (this.wantedCompletes < 1) {
        return this.sendMessage(this.parseTranslation(this.VALIDATION_WANTED_COMPLETES))
      }

      this.loadingSave = true

      const updatedSurvey = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'survey/quota',
        payload: {
          survey_id: this.$route.query.survey,
          quota: this.quotaJSON,
          quota_order: this.quotaOrder,
        },
      })

      if (!updatedSurvey) return (this.loadingSave = false)

      this.sendMessage(this.parseTranslation(this.UPDATED_QUOTA))

      await this.getSurvey()

      this.loadingSave = false
    },
  },
}
</script>

<style lang="scss" scoped>
.quotas {
  margin-top: 30px;
}

.buttons {
  @include flexAlignCenter;
  justify-content: flex-end;

  .add-agent {
    a {
      @include flexAlignCenter;
      @include tipography(16);
      font-weight: bold;
      padding: 10px 30px;
      border: 1px solid $white;
      border-radius: 3px;
      background: $transparent;
      transition: all 0.3s ease;
      text-transform: uppercase;

      &:hover {
        background: $main;
        border: 1px solid $main;
      }

      .light & {
        border: 1px solid $main;
        color: $main;

        &:hover {
          background: $gray-8;
          color: $white;
          border: 1px solid $gray-8;
        }
      }
    }
  }

  .btn-launch {
    display: block;
    @include tipography(16);
    background: $blue;
    font-weight: bold;
    padding: 10px 30px;
    border: 1px solid $blue;
    border-radius: 3px;
    margin-left: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    &:hover {
      background: $blue-2;
    }
    &:focus {
      outline: none;
    }
  }
}
</style>
